// extracted by mini-css-extract-plugin
export default {"header":"k5rxhHqufc0wTH_iRBgY"};